import { SalesLeadView } from "src/api/generated/erp/db/types/tables/salesLeadView.ts";

/** Changes whenever the lead or its primary contact changes, so lead form saves reload the contacts grid. */
export function getContactsGridKey(lead: SalesLeadView): string {
	return JSON.stringify([lead.salesLeadId, lead.contactName, lead.contactEmail, lead.contactPhone]);
}
